import { SUMMARY_ROW_ID } from '@fourthwall/module-analytics'

import type { AnalyticsReportStatsTable } from '../AnalyticsReport.types'

export const getCsvData = (statsTableData: AnalyticsReportStatsTable['data']) => {
  return statsTableData
    .filter(({ id }) => id !== SUMMARY_ROW_ID)
    .map(({ id, children, ...rest }) => rest) // removes ids and children
}
